export default __webpack_public_path__ + "static/media/timesheet-settings.d7bd3f4f.svg";